import { render, staticRenderFns } from "./orgAddClass.vue?vue&type=template&id=532ff200&scoped=true&"
import script from "./orgAddClass.js?vue&type=script&lang=js&"
export * from "./orgAddClass.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532ff200",
  null
  
)

export default component.exports